/**
 * Enumeration for the OptiDrive component KPI details.
 *
 * @readonly
 * @enum {string}
 */
export const OptiDriveComponentKpiDetails = {
    TRIPSTATS_DRIVINGTIME: 'tripstats_drivingtime',

    DRIVINGEVENTS_COUNT: 'drivingevents_count',
    DRIVINGEVENTS_AVG_SEVERITY: 'drivingevents_avg_severity',
    DRIVINGEVENTS_STEERING_AVG_SEVERITY: 'drivingevents_steering_avg_severity',

    ECOSTATS_FUELREFMILEAGE: 'ecostats_fuelrefmileage',
    ECOSTATS_FUELUSAGE: 'ecostats_fuelusage',
    ECOSTATS_FUELUSAGETOTAL: 'ecostats_fuelusagetotal',
    ECOSTATS_FUELREFUSAGETOTAL: 'ecostats_fuelrefusagetotal',

    CONSTANTSPEED_TIME_URBAN: 'constantspeed_time_urban',
    CONSTANTSPEED_REFTIME_URBAN: 'constantspeed_reftime_urban',
    CONSTANTSPEED_TIME_EXTRAURBAN: 'constantspeed_time_extraurban',
    CONSTANTSPEED_REFTIME_EXTRAURBAN: 'constantspeed_reftime_extraurban',
    CONSTANTSPEED_TIME_MOTORWAY: 'constantspeed_time_motorway',
    CONSTANTSPEED_REFTIME_MOTORWAY: 'constantspeed_reftime_motorway',

    COASTING_REFTIME: 'coasting_reftime',
    COASTING_TIME: 'coasting_time',

    CRUISECONTROL_USED_WITHIN_POTENTIAL_MILAGE: 'cruisecontrol_used_within_potential_mileage',
    CRUISECONTROL_POTENTIAL_MILAGE: 'cruisecontrol_potential_mileage',

    GREENSPEED_TIME: 'greenspeed_time',
    GREENSPEED_REFTIME: 'greenspeed_reftime',

    HIGHREVVING_AMPLITUDE: 'highrevving_amplitude',
    HIGHREVVING_LIMIT: 'highrevving_limit',
    HIGHREVVING_COUNT: 'highrevving_count',
    HIGHREVVING_TIME: 'highrevving_time',
    HIGHREVVING_REFTIME: 'highrevving_reftime',

    SPEEDINGEVENTS_SPEEDINGTIME: 'speedingevents_speedingtime',
    SPEEDINGEVENTS_SPEEDINGAMPLITUDE: 'speedingevents_speedingamplitude',
    SPEEDINGEVENTS_SPEEDLIMIT: 'speedingevents_speedlimit',
    SPEEDINGEVENTS_COUNT: 'speedingevents_count',

    ECOSTATS_IDLETIME: 'ecostats_idletime',
    ECOSTATS_WASTEDFUEL: 'ecostats_wastedfuel',

    CAMERA_EVENT_COUNT_SEATBELT: 'camera_event_count_seatbelt',
    CAMERA_EVENT_COUNT_SMOKING: 'camera_event_count_smoking',
    CAMERA_EVENT_COUNT_DROWSY: 'camera_event_count_drowsy',
    CAMERA_EVENT_COUNT_EATING: 'camera_event_count_eating',
    CAMERA_EVENT_COUNT_DISTRACTED: 'camera_event_count_distracted',
    CAMERA_EVENT_COUNT_MOBILE_PHONE: 'camera_event_count_mobile_phone'
}

Object.freeze(OptiDriveComponentKpiDetails)
